export enum ExternalUserTypeBehaviour {
  ValidatePhoneNumber = 1,
  NeedsReview = 2,
  EnrolmentEnabled = 4,
  CancerProgram = 8
}
